import tmhRequest from '@/config/tmhRequest'

export default {
    searchRefundProductOrderReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundproductorderreport/searchrefundproductorderreportcount',
            method: 'post',
            data: data,
        })
    },
    searchRefundProductOrderReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundproductorderreport/searchrefundproductorderreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportRefundProductOrderReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/refundproductorderreport/exportrefundproductorderreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/refundproductorderreport.js